import React, { useContext, useEffect, useState, useRef } from "react";
import { Pie } from "react-chartjs-2";
import { FaPlusCircle } from "react-icons/fa";
import {
  Addcategoryemployeemodal,
  Adddataemployeemodal,
  Addfixedexpenseemployeemodal,
} from "./Modal";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";
const TrackingEmployee = () => {
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const Category = ["Bills", "Household", "Car", "Grocery", "House Keeping"];
  const [isLoading, setIsLoading] = useState(false);
  const [expenseCategories, setExpenseCategories] = useState([]);
  const [showcategorymodal, setshowcategorymodal] = useState(false);
  const [moneydata, setmoneydata] = useState([]);
  const [showdatamodal, setshowdatamodal] = useState(false);
  const [filxedexpensemodal, setfilxedexpensemodal] = useState(false);
  const [fiexedexpensedata, setfiexedexpensedata] = useState([]);
  const [pieChartData, setPieChartData] = useState(null);
  const { password, username } = billpunchbasicauth;

  const openfixedexpensemodal = () => {
    setfilxedexpensemodal(true);
  };

  const closefixedexpensemodal = () => {
    setfilxedexpensemodal(false);
  };
  const opendatamodal = () => {
    setshowdatamodal(true);
  };

  const closedatamodal = () => {
    setshowdatamodal(false);
  };
  const openaddcategorymodal = () => {
    setshowcategorymodal(true);
  };

  const closeaddcategorymodal = () => {
    setshowcategorymodal(false);
  };
  const fetchExpenseCategories = async () => {
    setTransactionLoaderState(true);
    setIsLoading(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: user.userid,
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeDescription
          `,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setExpenseCategories(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
    setIsLoading(false);
  };
  const fetchMoneymanagement = async () => {
    setTransactionLoaderState(true);
    setIsLoading(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      var raw = JSON.stringify({
        empid: user.userid,
        firmid: user.firm_id,
      });

      var requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetEmployeeMoneyManagement
          `,
        requestOptions
      );
      const data = await res.json();
      if (data.status === "0") {
        setmoneydata(data.data);
      }
      setTransactionLoaderState(false);
    } catch (error) {
      console.log("error", error);
      setTransactionLoaderState(false);
    }
    setIsLoading(false);
  };
  const fetchFixedExpense = async () => {
    setTransactionLoaderState(true);

    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const raw = JSON.stringify({
        empid: user.userid,
        firmid: user.firm_id,
      });

      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: raw,
        redirect: "follow",
      };

      const response = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetMonthkyFixedExpense`,
        requestOptions
      );

      const data = await response.json();

      if (data.status === "0") {
        setfiexedexpensedata(data.data);

        // // Process data for pie chart
        const expenseTypes = data.data.map((item) => item.expensetype);
        const amounts = data.data.map((item) => parseFloat(item.amount));

        const pieData = {
          labels: expenseTypes,
          datasets: [
            {
              data: amounts,
              backgroundColor: [
                "rgba(255, 99, 132, 0.6)",
                "rgba(54, 162, 235, 0.6)",
                "rgba(255, 206, 86, 0.6)",
                "rgba(75, 192, 192, 0.6)",
                "rgba(153, 102, 255, 0.6)",
              ],
            },
          ],
        };

        setPieChartData(pieData);
      }

      setTransactionLoaderState(false);
    } catch (error) {
      console.error("Error fetching fixed expenses:", error);
      setTransactionLoaderState(false);
    }
  };
  useEffect(() => {
    fetchExpenseCategories();
    fetchMoneymanagement();
    fetchFixedExpense();
  }, []);
  return (
    <div className="mt-4">
      <h4 className="pt-3 px-md-4 px-2">Personal Finance Management</h4>

      <div className="row ">
        <div className="col-md-5 col">
          <Calculator />
          <h5 className="px-md-4 px-2">Check Your Fixed Expense</h5>
          {pieChartData && (
            <Pie
              data={pieChartData}
              options={{
                responsive: true,
                legend: {
                  display: false,
                },
              }}
            />
          )}
        </div>
        <div className="col-md-7 col">
          <div className="row m-0 p-0 pb-md-2 pb-1">
            <div className="col m-0 p-0 ">
              {" "}
              <h6> Money Management </h6>
            </div>
            <div className="col m-0 p-0 d-flex justify-content-end">
              <div
                className="d-flex justify-content-center align-items-center"
                style={{
                  backgroundColor: "rgba(43, 193, 85, 0.1)",
                  color: "rgba(43, 193, 85, 1)",
                  bordercolor: "rgba(43, 193, 85, 1)",
                  borderRadius: ".4rem",
                  border: "1px solid",
                  fontSize: ".8rem",
                  width: "3rem",
                  height: "1.5rem",
                }}
                onClick={opendatamodal}
              >
                {" "}
                Add
              </div>{" "}
            </div>
          </div>
          <div className="" style={{ height: "", overflow: "auto" }}>
            <table className="table table-bordered m-0 p-0 ">
              <thead>
                <tr style={{ borderBottom: "1px solid lightgrey" }}>
                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Name
                  </th>

                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Date
                  </th>

                  <th
                    className="text-center"
                    style={{
                      color: "#0074D9",
                      background: "#fff",
                      border: "none",
                    }}
                  >
                    Amount
                  </th>
                </tr>
              </thead>
              <tbody>
                {moneydata.length === 0 ? (
                  <tr>
                    <td colSpan="4" className="text-center">
                      No data available
                    </td>
                  </tr>
                ) : (
                  moneydata.map((item, index) => (
                    <tr
                      style={{ borderBottom: "1px solid lightgrey" }}
                      key={index}
                    >
                      <td
                        className="text-center align-middle"
                        style={{ border: "none" }}
                      >
                        {item.name || "NA"}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none" }}
                      >
                        {item.date || "NA"}
                      </td>
                      <td
                        className="text-center align-middle"
                        style={{ border: "none" }}
                      >
                        {item.amount || "NA"}
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <div className="row">
            <div
              className="col card m-0 p-2 mt-2 custom-scrollbaractivity"
              style={{
                background: "#fff",
                background: "rgba(0, 71, 171, 0.1)",
                overflowY: "auto",
                overflowX: "hidden",
                height: "50vh",
              }}
            >
              <div className="row ">
                <h6 className="col"> Fixed Expense</h6>
                <div className="col p-1 d-flex justify-content-end mr-3 ">
                  <div onClick={openfixedexpensemodal}>
                    {" "}
                    <FaPlusCircle style={{ color: "#0047AB" }} />
                  </div>
                </div>
              </div>
              <ul className="list-group">
                {fiexedexpensedata.length > 0 ? (
                  fiexedexpensedata.map((Fixed, index) => (
                    <li
                      key={index}
                      className="list-group-item"
                      style={{ border: "none" }}
                    >
                      <div className="d-flex justify-content-between">
                        <span>{Fixed.expensetype}</span>
                        <span style={{ color: "red" }}>{Fixed.amount}</span>
                      </div>
                    </li>
                  ))
                ) : (
                  <li className="list-group-item" style={{ border: "none" }}>
                    <div className="d-flex justify-content-center">
                      No data found
                    </div>
                  </li>
                )}
              </ul>
            </div>
            <div className="col-md-4 col">
              <div
                className="card m-0 p-md-2 mt-2"
                style={{ background: "#fff" }}
              >
                <div className="row ">
                  <h6 className="col p-1"> Category</h6>
                  <div className="col p-1 d-flex justify-content-end mr-3 ">
                    <div onClick={openaddcategorymodal}>
                      {" "}
                      <FaPlusCircle style={{ color: "#0047AB" }} />
                    </div>
                  </div>
                </div>
                <ul className="list-group">
                  {expenseCategories.length > 0 ? (
                    expenseCategories.map((category, index) => (
                      <li
                        key={index}
                        className="list-group-item p-1"
                        style={{ border: "none" }}
                      >
                        <span>{category.category}</span>
                      </li>
                    ))
                  ) : (
                    <li
                      className="list-group-item p-1"
                      style={{ border: "none" }}
                    >
                      <div className="d-flex justify-content-center">
                        No data found
                      </div>
                    </li>
                  )}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Addcategoryemployeemodal
        show={showcategorymodal}
        hide={closeaddcategorymodal}
        fetchExpenseCategories={fetchExpenseCategories}
      />
      <Addfixedexpenseemployeemodal
        show={filxedexpensemodal}
        hide={closefixedexpensemodal}
        fetchExpenseCategories={fetchExpenseCategories}
        expenseCategories={expenseCategories}
        fetchFixedExpense={fetchFixedExpense}
      />
      <Adddataemployeemodal
        show={showdatamodal}
        hide={closedatamodal}
        fetchMoneymanagement={fetchMoneymanagement}
      />
    </div>
  );
};
const Calculator = () => {
  const [input, setInput] = useState("");
  const [result, setResult] = useState("");
  const [isFocused, setIsFocused] = useState(false);
  const calculatorRef = useRef(null);

  const handleButtonClick = (value) => {
    setInput(input + value);
  };

  const handleClear = () => {
    setInput("");
    setResult("");
  };

  const handleCalculate = () => {
    try {
      setResult(eval(input).toString());
    } catch (error) {
      setResult("Error");
    }
  };

  const handleBackspace = () => {
    setInput(input.slice(0, -1));
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (isFocused) {
        const { key } = event;
        if (/[0-9+\-*/.=]|Enter|Escape|Backspace/.test(key)) {
          event.preventDefault();
          if (key === "Enter") {
            handleCalculate();
          } else if (key === "Escape") {
            handleClear();
          } else if (key === "Backspace") {
            handleBackspace();
          } else {
            handleButtonClick(key);
          }
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [
    isFocused,
    handleButtonClick,
    handleCalculate,
    handleClear,
    handleBackspace,
  ]);

  return (
    <div
      ref={calculatorRef}
      style={calculatorStyle}
      tabIndex={0}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      <div style={headerStyle}>Calculator</div>
      <div style={displayStyle}>
        <input type="text" value={input} readOnly style={inputStyle} />
        <span style={resultStyle}>{result}</span>
      </div>
      <div style={buttonGridStyle}>
        <button onClick={() => handleButtonClick("7")} style={buttonStyle}>
          7
        </button>
        <button onClick={() => handleButtonClick("8")} style={buttonStyle}>
          8
        </button>
        <button onClick={() => handleButtonClick("9")} style={buttonStyle}>
          9
        </button>
        <button onClick={() => handleButtonClick("/")} style={operatorStyle}>
          /
        </button>
        <button onClick={() => handleButtonClick("4")} style={buttonStyle}>
          4
        </button>
        <button onClick={() => handleButtonClick("5")} style={buttonStyle}>
          5
        </button>
        <button onClick={() => handleButtonClick("6")} style={buttonStyle}>
          6
        </button>
        <button onClick={() => handleButtonClick("*")} style={operatorStyle}>
          X
        </button>
        <button onClick={() => handleButtonClick("1")} style={buttonStyle}>
          1
        </button>
        <button onClick={() => handleButtonClick("2")} style={buttonStyle}>
          2
        </button>
        <button onClick={() => handleButtonClick("3")} style={buttonStyle}>
          3
        </button>
        <button onClick={() => handleButtonClick("-")} style={operatorStyle}>
          -
        </button>
        <button onClick={() => handleButtonClick("0")} style={buttonStyle}>
          0
        </button>
        <button onClick={() => handleButtonClick(".")} style={buttonStyle}>
          .
        </button>
        <button
          onClick={handleClear}
          style={{
            ...buttonStyle,
            backgroundColor: "#e74c3c",
            gridColumn: "span 2",
          }}
        >
          C
        </button>
        <button onClick={() => handleButtonClick("+")} style={operatorStyle}>
          +
        </button>
        <button
          onClick={handleCalculate}
          style={{
            ...buttonStyle,
            backgroundColor: "#2ecc71",
            gridColumn: "span 2",
          }}
        >
          =
        </button>
        <button
          onClick={handleBackspace}
          style={{ ...buttonStyle, backgroundColor: "#f39c12" }}
        >
          ←
        </button>
      </div>
    </div>
  );
};

const calculatorStyle = {
  width: "300px",
  margin: "20px auto",
  fontFamily: "Arial, sans-serif",
  boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.1)",
  borderRadius: "10px",
  overflow: "hidden",
  outline: "none", // For focus styles
};

const headerStyle = {
  backgroundColor: "#2c3e50",
  color: "#fff",
  padding: "10px",
  borderRadius: "10px 10px 0 0",
};

const displayStyle = {
  backgroundColor: "#f1f1f1",
  padding: "10px",
  marginBottom: "10px",
  borderRadius: "0 0 10px 10px",
};

const inputStyle = {
  width: "calc(100% - 20px)",
  marginBottom: "5px",
  padding: "8px",
  fontSize: "16px",
  border: "none",
  borderRadius: "3px",
  boxShadow: "inset 0 1px 2px rgba(0, 0, 0, 0.1)",
  boxSizing: "border-box",
};

const resultStyle = {
  fontSize: "18px",
  display: "block",
  textAlign: "right",
};

const buttonGridStyle = {
  display: "grid",
  gridTemplateColumns: "repeat(4, 1fr)",
  gridGap: "5px",
  overflow: "hidden",
};

const buttonStyle = {
  padding: "15px",
  fontSize: "18px",
  border: "none",
  outline: "none",
  cursor: "pointer",
  backgroundColor: "#3498db",
  color: "#fff",
  borderRadius: "5px",
  transition: "background-color 0.3s",
};

const operatorStyle = {
  ...buttonStyle,
  backgroundColor: "#f39c12",
};
export default TrackingEmployee;
